export default "__VITE_ASSET__Ca2aiV4J__"